import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';
import { PersonCreate } from '@wdx/clmi/clmi-swagger-gen';

@Injectable()
export class ProspectsService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    create(prospectCreateData: PersonCreate): Observable<PersonCreate> {
        return this.http.post<PersonCreate>(
            `${this.config.getConfiguration().API_BASE}/person`,
            prospectCreateData,
        );
    }
}
